type TriState = 'any' | 'yes' | 'no';

export class ClientFilters {
  name: string = '';
  active: TriState = 'any';
  terminated: TriState = 'no';
  fileProcessingEnabled: TriState = 'any';
  entityTypes: string[] = [];
  state: null | string = null;
  assignedClientLeads: string[] = [];
  hrsaId: string = '';
}
